var alignment_rtlignore_default = {
  "alignLeft": "h0uf7",
  "textWrapNowrap": "_9jerm",
  "alignRight": "UZ4Il",
  "alignCenter": "Eqb24",
  "sizeFullWidth": "z3mrF",
  "renderedInTable": "n8zNR",
  "sizeOriginal": "sZnU7",
  "sizeContent": "rYfrg",
  "sizeSmall": "YwZFE",
  "sizeSmallCenter": "ADw-0",
  "flex": "PEXcL",
  "LEFT": "O9HT9",
  "CENTER": "xwctV",
  "RIGHT": "x7MzU",
  "AUTO": "Mghxl",
  "JUSTIFY": "_8Kpoz"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
